(function () {
  var CYCLE_MS = 11 * 60 * 60 * 1000;

  function pad(n) {
    n = Math.floor(n);
    if (isNaN(n) || n < 0) n = 0;
    return (n < 10 ? '0' : '') + String(n);
  }

  function parseEndDate(rawDate, rawTime) {
    if (!rawDate || typeof rawDate !== 'string') return null;
    var date = rawDate.trim();
    if (!date || date === 'null' || date === 'blank') return null;

    var time = (rawTime && typeof rawTime === 'string' && rawTime.trim() !== '') ? rawTime.trim() : '23:59';
    var parsed = new Date(date + 'T' + time + ':00');
    return isNaN(parsed.getTime()) ? null : parsed;
  }

  function getSharedDiff(now) {
    return CYCLE_MS - (now % CYCLE_MS);
  }

  function initTimer(root) {
    if (!root || root.getAttribute('data-sct-initialized') === 'true') return;
    root.setAttribute('data-sct-initialized', 'true');

    var endTime = parseEndDate(root.getAttribute('data-sct-date'), root.getAttribute('data-sct-time'));
    var usingFallback = !endTime;

    var parts = {
      d: root.querySelector('[data-sct-part="d"]'),
      h: root.querySelector('[data-sct-part="h"]'),
      m: root.querySelector('[data-sct-part="m"]'),
      s: root.querySelector('[data-sct-part="s"]')
    };

    if (!parts.d || !parts.h || !parts.m || !parts.s) return;

    function setN(key, val) {
      var el = parts[key];
      if (!el) return;
      var next = pad(val);
      if (el.textContent !== next) {
        el.textContent = next;
        el.classList.remove('sct-tick');
        el.classList.add('sct-tick');
        window.setTimeout(function () {
          el.classList.remove('sct-tick');
        }, 200);
      }
    }

    function tick() {
      var now = Date.now();
      var diff;

      if (usingFallback) {
        diff = getSharedDiff(now);
      } else if (endTime) {
        diff = endTime.getTime() - now;
      } else {
        diff = getSharedDiff(now);
      }

      if (diff <= 0) {
        if (usingFallback) {
          diff = CYCLE_MS;
        } else {
          setN('d', 0);
          setN('h', 0);
          setN('m', 0);
          setN('s', 0);
          var blocks = root.querySelector('.sct-blocks');
          if (blocks) blocks.style.opacity = '0.4';
          return false;
        }
      }

      setN('d', diff / 86400000);
      setN('h', (diff % 86400000) / 3600000);
      setN('m', (diff % 3600000) / 60000);
      setN('s', (diff % 60000) / 1000);
      return true;
    }

    tick();
    var intervalId = window.setInterval(function () {
      if (tick() === false && !usingFallback) {
        window.clearInterval(intervalId);
      }
    }, 1000);
  }

  function initAll() {
    var timers = document.querySelectorAll('[data-sale-timer]');
    for (var i = 0; i < timers.length; i++) {
      initTimer(timers[i]);
    }
  }

  function boot() {
    initAll();
  }

  if (!window.__saleTimerReady) {
    window.__saleTimerReady = true;
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
    document.addEventListener('shopify:section:load', boot);
  } else {
    boot();
  }
})();
